import { Container } from '@mui/material';
import React from 'react';
import {
    CALCULATOR_INTRO_PUBLIC,
    CALCULATOR_INTRO_TITLE,
} from '../../components/calculator/calculatorIntroCopy';
import PriceCalculatorPanel from '../../components/calculator/PriceCalculatorPanel';
import Footer from '../../components/front/Footer';
import Header from '../../components/front/Header';
import './style.css';

function PublicCalculatorPage() {
    return (
        <div className="public-calculator-page">
            <Header />
            <main>
                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <PriceCalculatorPanel
                        variant="public"
                        introTitle={CALCULATOR_INTRO_TITLE}
                        intro={CALCULATOR_INTRO_PUBLIC}
                    />
                </Container>
            </main>
            <Footer />
        </div>
    );
}
export default PublicCalculatorPage;
